import {SelectCountryPhone} from "../../parts/bottom-sheet-content/select-country-phone"
import {SelectCountry} from "../../parts/bottom-sheet-content/select-country"
import {SelectProductOption} from "../../parts/bottom-sheet-content/select-product"
import {AddPaymentCard} from "../../parts/bottom-sheet-content/payment/add-card"
import {EditPaymentCard} from "../../parts/bottom-sheet-content/payment/edit-card"
import {AddCardFormSubmit} from "../payment/add-card"

export class OpenBottomSheet {
    constructor(optionalOptions = {}) {
        this._sheetButtons = document.querySelectorAll('.open-sheet');

        if (!this._sheetButtons) {
            this.destructor();
            return true;
        }

        this.minHeight = 50;
        let thatSheet
        let thatSheetContents
        let thatDraggableArea
        let sheetHeight
        let buttonTemplateAttr
        let buttonTemplateTitle
        let buttonTemplateInputTarget
        let buttonTemplateTextTarget

        let touchPosition = (event) =>
            event.touches ? event.touches[0] : event

        let dragPosition

        const setSheetHeight = (value) => {
            sheetHeight = Math.max(0, Math.min(100, value))
            thatSheetContents.style.height = `${sheetHeight}vh`
            if (sheetHeight === 100) {
                thatSheetContents.classList.add("fullscreen")
            } else {
                thatSheetContents.classList.remove("fullscreen")
            }
        }

        const setIsSheetShown = (value) => {
            thatSheet.setAttribute("aria-hidden", String(!value))
            if (value) {
                document.body.classList.add("sheet-opened");
            } else {
                document.body.classList.remove("sheet-opened");
            }
        }

        const onDragStart = (event) => {
            dragPosition = touchPosition(event).pageY
            thatSheetContents.classList.add("not-selectable")
            event.currentTarget.areaParam.style.cursor = document.body.style.cursor = "grabbing"
        }

        const onDragMove = (event) => {
            if (dragPosition === undefined) return
            const y = touchPosition(event).pageY
            const deltaY = dragPosition - y
            const deltaHeight = deltaY / window.innerHeight * 100
            setSheetHeight(sheetHeight + deltaHeight)
            dragPosition = y
        }

        const onDragEnd = () => {
            dragPosition = undefined
            thatSheetContents.classList.remove("not-selectable")
            //event.currentTarget.areaParam.style.cursor = document.body.style.cursor = ""
            if (sheetHeight < 25) {
                setIsSheetShown(false)
            } else if (sheetHeight > 75) {
                setSheetHeight(100)
            } else {
                setSheetHeight(this.minHeight)
            }
        }

        this._sheetButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault();

                buttonTemplateAttr = button.dataset.template
                buttonTemplateTitle = button.dataset.title

                if (button.dataset.inputTarget) {
                    buttonTemplateInputTarget = button.dataset.inputTarget
                }

                if (button.dataset.textTarget) {
                    buttonTemplateTextTarget = button.dataset.textTarget
                }

                if (button.dataset.minheight) {
                    let heightSheet = parseInt(button.dataset.minheight, 10);
                    if (heightSheet > 0) {
                        this.minHeight = parseInt(button.dataset.minheight, 10);
                    }
                }

                if (!buttonTemplateAttr) {
                    return false
                }

                thatSheet = document.getElementById(buttonTemplateAttr)
                if (!thatSheet) {
                    return false
                }

                thatSheetContents = thatSheet.querySelector(".sheet-contents")
                thatDraggableArea = thatSheet.querySelectorAll(".sheet-draggable-area")

                thatDraggableArea.forEach((area) => {
                    area.addEventListener("mousedown", onDragStart)
                    area.areaParam = area
                    area.addEventListener("touchstart", onDragStart)
                })

                window.addEventListener("mousemove", onDragMove)
                window.addEventListener("touchmove", onDragMove)
                window.addEventListener("mouseup", onDragEnd)
                window.addEventListener("touchend", onDragEnd)

                thatSheet.querySelector(".sheet-close-sheet").addEventListener("click", () => {
                    setIsSheetShown(false)
                })

                thatSheet.querySelector(".sheet-overlay").addEventListener("click", () => {
                    setIsSheetShown(false)
                })

                setIsSheetShown(false)

                thatSheet.querySelector(".sheet-body").dataset.inputTarget = "";
                if (buttonTemplateInputTarget) {
                    thatSheet.querySelector(".sheet-body").dataset.inputTarget = buttonTemplateInputTarget;
                }

                thatSheet.querySelector(".sheet-body").dataset.textTarget = "";
                if (buttonTemplateTextTarget) {
                    thatSheet.querySelector(".sheet-body").dataset.textTarget = buttonTemplateTextTarget;
                }

                if (buttonTemplateAttr === '.payment-bottom--add-card') {
                    this.minHeight = 90;
                }

                if (buttonTemplateAttr === '.payment-bottom--edit-card') {
                    this.minHeight = 90;
                }

                setSheetHeight(Math.min(this.minHeight, 720 / window.innerHeight * 100))

                setIsSheetShown(true)
            })
        })
    }

    destructor() {
        this._sheetButtons = null;
    }
}

export default new OpenBottomSheet();
